import { useState } from "react";
import { toast } from "sonner";

import { sendContactMessage } from "@/services/contactService";
import { getErrorMessage } from "@/services/apiClient";

const EMPTY_FORM = { name: "", email: "", subject: "", message: "" };

// Renders just the form itself (no image, no outer section) -- it's meant to be dropped into
// the two-column Material card on the Contact page (see ContactUs.js), which owns the
// surrounding layout/elevation.
const ContactForm = () => {

  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await sendContactMessage(form);
      toast.success(res.message || "Message sent!");
      setForm(EMPTY_FORM);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form id="contact-form" onSubmit={handleSubmit} className="rbt-material-form">
      <div className="rbt-material-form__row">
        <div className="rbt-material-field">
          <label htmlFor="contact-name">Full name</label>
          <input
            name="name"
            id="contact-name"
            type="text"
            placeholder="Jane Doe"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="rbt-material-field">
          <label htmlFor="contact-email">Email address</label>
          <input
            name="email"
            id="contact-email"
            type="email"
            placeholder="you@example.com"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="rbt-material-field">
        <label htmlFor="contact-subject">Subject</label>
        <input
          type="text"
          id="contact-subject"
          name="subject"
          placeholder="What's this about?"
          value={form.subject}
          onChange={handleChange}
          required
        />
      </div>

      <div className="rbt-material-field">
        <label htmlFor="contact-message">Message</label>
        <textarea
          name="message"
          id="contact-message"
          placeholder="Tell us a bit more…"
          rows={5}
          value={form.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <button type="submit" className="rbt-btn btn-gradient icon-hover w-100 d-block text-center" disabled={submitting}>
        <span className="btn-text">{submitting ? "Sending…" : "Send Message"}</span>
        <span className="btn-icon"><i className="feather-arrow-right"></i></span>
      </button>
    </form>
  );
};

export default ContactForm;
